import { Controller } from "@hotwired/stimulus"
import { loadConnectAndInitialize } from "@stripe/connect-js"

export default class extends Controller {
  static values = {
    publishableKey: String,
    accountSessionUrl: String
  }

  static targets = ["container", "loader", "error"]

  connect() {
    this.fetchClientSecret = this.fetchClientSecret.bind(this)
    this.initConnect()
  }

  async fetchClientSecret() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.accountSessionUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken || "",
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })

    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.error || "Failed to create account session")
    }

    const { client_secret: clientSecret } = await response.json()
    return clientSecret
  }

  async initConnect() {
    try {
      const stripeConnectInstance = loadConnectAndInitialize({
        publishableKey: this.publishableKeyValue,
        fetchClientSecret: this.fetchClientSecret
      })

      const documentsComponent = stripeConnectInstance.create("documents")

      if (this.hasLoaderTarget) {
        documentsComponent.setOnLoaderStart(() => {
          this.loaderTarget.hidden = true
        })
      }

      if (this.hasErrorTarget) {
        documentsComponent.setOnLoadError((loadError) => {
          this.errorTarget.textContent = loadError.error?.message || "Failed to load documents"
          this.errorTarget.hidden = false
        })
      }

      this.containerTarget.appendChild(documentsComponent)
    } catch (err) {
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = err.message || "Something went wrong"
        this.errorTarget.hidden = false
      }
      if (this.hasLoaderTarget) {
        this.loaderTarget.hidden = true
      }
    }
  }
}
